import React from 'react';
import BaseComponent, {AjaxParam} from '../../common/BaseComponent/BaseComponent';
import styles from './ComponentInvoiceBlock.scss';
import Radio from "../../common/primitives/Radio";
import Label from "../../common/primitives/Label";
import TextSelectStyle from '../../common/primitives/TextSelectStyle';
import ComponentCompanyForm from "../ComponentCompanyForm/ComponentCompanyForm";
import ExistingCompanyInfo from "./ExistingCompanyInfo";
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import {_hasProperty} from '../../common/helpers/HelperFunc';
import Button from "../../common/primitives/Button";
import {__t} from '../../common/lang/text-resource';
import {notify} from "../../common/primitives/Notification/Notification";
import Select from "../../common/primitives/Select";

class ComponentInvoiceBlock extends BaseComponent {

	data = {};
	companyForm = {};
	selectedMode = 'without_invoice';  //with_company_form, without_invoice, with_existing_company, edit_existing
	newCompanyId = 'new_company_id';
	emptyCompanyForm = {
		company_name: '',
		company_country: 'BG',
		company_address: '',
		company_city: '',
		company_eik: '',
		company_tax_number: '',
		company_code: '',
		company_mol: '',
		company_id: this.newCompanyId,
		company_phone_code: 'BG',
		company_phone: '',
		eikegn: 'eik',
	};
	selectedCompanyData = this.emptyCompanyForm;
	newCustomerName = '';

	constructor() {
		super(...arguments, 'ComponentInvoiceBlock');

		this.companyRef = React.createRef();
		this.companyForm = this.context.get('ComponentCompanyForm');
		this.data = this.context.get(this.componentName);
		if (this.data) {
			this.data = this.data.componentData;
		}

		this.selectedCompanyId = this.data.selectedCompany;
		const companiesData = this.data.companiesData;
		const companiesDataSelect = this.data.companiesDataSelect;
		this.selectedCompanyData = this.companyForm.componentData.companyData;

		//по подразбиране от backend-а идва new_company_id. Разбираме, че е без фактура, ако няма въведени данни в количката.
		this.isEmptyNewCompany = this.selectedCompanyId === this.newCompanyId && this.selectedCompanyData.company_name === '';

		if (companiesData.length > 0) {
			if (this.isEmptyNewCompany !== true) {
				this.selectedMode = 'with_existing_company';
			}
		}

		this.context.set(this.componentName + 'smode', this.selectedMode);
		this.context.set(this.componentName + 'scid', this.selectedCompanyId);

		//Използва се и от NoCompanySelectedPopup
		this.context.set(this.componentName + 'scompd', this.findCompanyById(this.selectedCompanyId));
	}

	eventConsume(actionName, actionObject) {
		if (actionName === 'OnBlurNewCustomerNameTriggered', _hasProperty(actionObject, 'value')) {
			this.newCustomerName = actionObject.value;
			this.setState(this.state);
		}
	}

	getComponentState = () => {
		let companyForm = this.companyRef.current;
		let companyData = this.context.get(this.componentName + 'scompd');
		if (this.selectedMode === 'with_company_form' || this.selectedMode === 'edit_existing') {
			companyForm = Object.assign({}, companyForm.getComponentState());
			companyData = companyForm.companyData;
		}

		return {
			companyData: companyData,
			selectedMode: this.selectedMode,
			selectedId: companyData.company_id,
			customerId: this.data.customerId,
			cartId: this.data.cartId
		};
	};

	componentValidate = () => {
		let companyForm = this.companyRef.current;
		if (companyForm) {
			return companyForm.componentValidate();
		}
		return true;
	};

	saveCompanyData = () => {
		if (!this.componentValidate()) {
			return;
		}

		const ajaxParam = new AjaxParam();

		ajaxParam.callbackError = (data) => {
			notify.error(this.messages[data.componentErrors[0]] || data.componentErrors[0]);
			this.rootPage().forceUpdate();
		}

		this.rootPage().ajaxCall('ActionManageCompanyData', this.getComponentState(), ajaxParam);
	};

	findCompanyById = id => {
		const {
			companiesData
		} = this.data;

		let ret = Object.assign({}, this.emptyCompanyForm);

		if (!companiesData) {
			return ret;
		}
		const companyFound = companiesData.filter((data) => {
			if (data.company_id === id) {
				return data;
			}
		});
		if (companyFound.length) {
			return companyFound[0];
		}

		return ret;
	};

	selectMode = (mode) => {
		this.selectedMode = mode;
		this.context.set(this.componentName + 'smode', this.selectedMode);
		this.context.set(this.componentName + 'scid', this.selectedCompanyId);
		this.context.set(this.componentName + 'scompd', this.findCompanyById(this.selectedCompanyId));
		this.context.forceUpdate(this.componentName);
		this.eventRaise('InvoiceCompanyModeChanged', {selectedMode: this.selectedMode});
	};

	editExistingCompany = () => {
		this.companyForm.componentData.companyData = Object.assign({}, this.findCompanyById(this.selectedCompanyId));
		this.selectMode('edit_existing');
		this.setState(this.state);
	};

	cancelEdit = () => {
		let sm = 'without_invoice';

		this.isEmptyNewCompany = this.selectedCompanyId === this.newCompanyId && this.selectedCompanyData.company_name === '';

		if (!this.isEmptyNewCompany) {
			sm = 'with_existing_company';
		}
		this.setState(this.state);

		this.selectMode(sm);  //with_company_form, without_invoice, with_existing_company
	};

	changeMode = selectedMode => {
		this.selectedCompanyId = this.context.get(this.componentName + 'scid');

		if (selectedMode === 'with_company_form') {
			this.companyForm.componentData.companyData = Object.assign({}, this.findCompanyById(this.newCompanyId));
		}

		if (selectedMode === 'with_existing_company') {
			let selected = this.selectedCompanyId;
			const {
				companiesData
			} = this.data;
			if (this.selectedCompanyId === this.newCompanyId) {
				selected = companiesData[0].company_id;
				this.selectedCompanyId = selected;
			}

			this.companyForm.componentData.companyData = Object.assign({}, this.findCompanyById(selected));
			this.selectedCompanyData = Object.assign({}, this.findCompanyById(selected));
		}

		if (selectedMode === 'without_invoice') {
			this.companyForm.componentData.companyData = Object.assign({}, this.emptyCompanyForm);
			this.selectedCompanyData = Object.assign({}, this.emptyCompanyForm);
			this.selectedCompanyId = this.newCompanyId;

		}
		this.selectMode(selectedMode);

		//ако сме избрали без фактура, трябва да изчистим стойността в контекста за SelectedCompanyData,
		//без да се използва метода this.findCompanyById, защото, може да върне нововъведена фирма.
		if (selectedMode === 'without_invoice') {
			this.context.set(this.componentName + 'scompd', Object.assign({}, this.emptyCompanyForm));
			this.context.forceUpdate(this.componentName);
		}

		this.setState(this.state);
	};

	onChangeExistingCompany = selected => {
		this.selectedCompanyId = selected.company_id ?? selected.value;

		this.selectMode('with_existing_company');

		const newCompany = this.findCompanyById(this.selectedCompanyId);

		const oldCountry = this.selectedCompanyData.company_country;
		const newCountry = newCompany.company_country;

		this.selectedCompanyData = Object.assign({}, newCompany);
		this.companyForm.componentData.companyData = Object.assign({}, this.selectedCompanyData);
		this.setState(this.state);
		this.context.forceUpdate(this.componentName);


		/**
		 * https://ps.superhosting.bg/projects/483?modal=Task-53898-483
		 *
		 * Ако дъравата на досегашната фирма е различна от новоизбраната,
		 * се reload-ва страницата.
		 *
		 * Ако има флаг за reload на смяна на фирма, да се reload-не страницата и да се зареди друг валутен режим.
		 * Проверява: дали държавата на новата и старата фирма са различни.
		 * Ако са различни, задава новата фирма и reload-ва страницата.
		 */

		if (this.props.reloadOnCompanyChange) {

			let ajaxParam = new AjaxParam();
			ajaxParam.isLoading = 1;

			if (oldCountry != newCountry) {
				this.rootPage().ajaxCall('ActionUpdateCartCompanyData', {
					  cartId: this.data.cartId,
					  companyId: this.selectedCompanyId
				  },
				  ajaxParam);
			}
		}
	};

	getVariables = () => {
		this.selectedMode = this.context.get(this.componentName + 'smode');
		this.selectedCompanyId = this.context.get(this.componentName + 'scid');
		this.selectedCompanyData = this.context.get(this.componentName + 'scompd');
	}

	getCompanyFormData = () => {
		let companyForm = this.context.get('ComponentCompanyForm');

		let tmpCompanyForm = {};

		if ((this.selectedMode === 'with_company_form' || this.selectedMode === 'edit_existing') && this.props.allowNewCompany) {
			tmpCompanyForm = companyForm;

			if (this.selectedMode === 'with_company_form') {
				tmpCompanyForm.componentData.companyData = Object.assign({}, this.emptyCompanyForm);
			}
		}

		return tmpCompanyForm;
	}

	getPersonalCompanyForm = () => {

		this.getVariables();

		const {
			loggedIn,
			customerName
		} = this.data;

		if (this.props.disableInvoiceBlock !== true) {
			return (
			  <div className={styles.row} data-test="without_invoice_container">
				  <div className={styles.firstCol}>
					  <Radio
						value='without_invoice'
						id='without_invoice'
						checked={this.selectedMode === 'without_invoice'}
						labelClass={styles.companyRadio}
						onChange={() => this.changeMode('without_invoice')}/>
				  </div>
				  <div className={styles.secondCol}>
					  <Label htmlFor='without_invoice'
							 text={`${loggedIn === true && customerName ? `${customerName}` : this.newCustomerName !== '' ? this.newCustomerName : __t('Физическо лице')}`}/>
				  </div>
			  </div>
			);
		}

	}


	getAddNewCompanyForm = () => {

		this.getVariables();

		const {
			loggedIn
		} = this.data;

		let tmpCompanyForm = this.getCompanyFormData();

		if (this.props.allowNewCompany === true) {
			return (
			  <>
				  <div
					data-test="component_invoice"
					className={`${styles.container} ${loggedIn === true && styles.loggedIn} ${this.props.allowNewCompany !== true && styles.withoutCompanyContainer}`}>
					  <div className={styles.row} data-test="new_company_container">
						  <div className={styles.firstCol}>
							  <Radio
								value='with_company_form'
								id='with_company_form'
								checked={this.selectedMode === 'with_company_form'}
								labelClass={styles.companyRadio}
								onChange={() => this.changeMode('with_company_form')}/>
						  </div>
						  <div className={styles.secondCol}>
							  <Label htmlFor='with_company_form' text={__t('Добавяне на фирма')}/>
						  </div>
					  </div>
				  </div>

				  {this.selectedMode === 'with_company_form' ?
					<ComponentCompanyForm
					  data={tmpCompanyForm}
					  ref={this.companyRef}
					  cancelButtonAction={this.cancelEdit}
					  editMode={this.selectedMode === 'edit_existing'}
					  showSaveButton={this.props.showCompanyFormSaveButtonForAdd}
					  saveAction={this.saveCompanyData}
					  closeButtonHide={(this.props.blockType === 'logged' || this.props.blockType === 'quick-renew' || this.props.blockType === 'cart-completed')}
					  closeButtonText={this.props.blockType === 'register' ? __t('Изтриване на данни за фирма') : ''}
					/>
					: ''}
			  </>
			);
		}

	}


	getMultipleCompanyForm = () => {

		this.getVariables();

		const {
			companiesData,
			companiesDataSelect,
			loggedIn
		} = this.data;

		let tmpCompanyForm = this.getCompanyFormData();

		/////////////////////////////////////////////////////////////////////////////////////////
		// Custom textselect style

		let textSelectStyle = TextSelectStyle();

		let menu = textSelectStyle.menu();
		menu.textAlign = 'left';
		menu.width = 'max-content';
		menu.cursor = 'pointer';
		menu.zIndex = '1';
		delete menu.maxWidth;
		delete menu.minWidth;

		let option = textSelectStyle.option('', {});
		option.padding = '0 30px 0 30px';

		textSelectStyle.menu = () => (menu);
		textSelectStyle.option = () => (option);

		/////////////////////////////////////////////////////////////////////////////////////////

		return (
		  <>
			  <div
				data-test="component_invoice"
				className={`${styles.container} ${styles.mbExistingBlock} ${loggedIn === true && styles.loggedIn} ${this.props.allowNewCompany !== true && styles.withoutCompanyContainer}`}>

				  <div className={`${styles.row} ${styles.headerContainer}`}>
					  <div className={styles.firstCol}>
					  </div>
					  <div className={styles.secondCol}>
						  <h2
							data-layout={!loggedIn ? 'padding-top--smm margin-top--md margin-bottom--md' : ''}>{__t('Фактура')}</h2>
					  </div>
				  </div>

				  {/* ------------- ФИЗИЧЕСКО ЛИЦЕ ------------- */}
				  {this.getPersonalCompanyForm()}

				  {/* ------------- COMBO АКО ИМА ПОВЕЧЕ ОТ ЕДНА ФИРМА ------------- */}
				  {
					  <div className={styles.row} data-test="existing_companies_select_container">
						  <div className={styles.firstCol}>
							  <Radio
								value='with_existing_company'
								id='with_existing_company'
								checked={(this.selectedMode === 'with_existing_company' || this.selectedMode === 'edit_existing')}
								labelClass={styles.companyRadio}
								onChange={() => this.changeMode('with_existing_company')}/>
						  </div>
						  <div className={styles.secondCol}>
							  {
								  companiesData.length === 1 || this.props.disableInvoiceBlock === true ?
									<label htmlFor="with_existing_company">
										{this.selectedCompanyId === this.newCompanyId && this.selectedCompanyData.company_name === '' ? companiesData[0].company_name : this.selectedCompanyData.company_name}
									</label> :
									<Select
									  name={"existing_company"}
									  placeholder={__t('Избор на фирма...')}
									  options={companiesDataSelect}
									  selected={this.selectedCompanyId === this.newCompanyId && this.selectedCompanyData.company_name === '' ? '' : this.selectedCompanyId}
									  onChange={this.onChangeExistingCompany}
									  isSearchable={true}
									/>
							  }
						  </div>

					  </div>
				  }

				  {/* ------------- ДАННИТЕ ЗА ИЗБРАНАТА ФИРМА ------------- */}
				  {
					  (this.selectedMode === 'edit_existing') && this.props.allowNewCompany ?
						''
						:
						(this.selectedMode === 'with_existing_company' && companiesData.length > 1) &&
						<ExistingCompanyInfo
						  editExistingCompany={this.editExistingCompany}
						  allowEdit={companiesData.length > 0 && this.props.allowNewCompany}
						  companyInfo={this.findCompanyById(this.selectedCompanyId)}/>
				  }

			  </div>

			  {/* ------------- ФОРМАТА ЗА РЕДАКТИРАНЕ НА ФИРМА ------------- */}
			  {(this.selectedMode === 'edit_existing') && this.props.allowNewCompany ?
				<ComponentCompanyForm
				  data={tmpCompanyForm}
				  ref={this.companyRef}
				  cancelButtonAction={this.cancelEdit}
				  editMode={this.selectedMode === 'edit_existing'}
				  showSaveButton={this.props.showCompanyFormSaveButtonForEdit}
				  saveAction={this.saveCompanyData}
				  closeButtonHide={true}
				/>
				: ''}
		  </>
		);

	}

	getSingleCompanyForm = () => {

		this.getVariables();

		const {
			companiesData,
			loggedIn
		} = this.data;

		let tmpCompanyForm = this.getCompanyFormData();

		return (
		  <>
			  <div
				data-test="component_invoice"
				className={`${styles.container} ${styles.mbExistingBlock} ${loggedIn === true && styles.loggedIn} ${this.props.allowNewCompany !== true && styles.withoutCompanyContainer}`}>

				  <div className={`${styles.row} ${styles.headerContainer}`}>
					  <div className={styles.firstCol}>
					  </div>
					  <div className={styles.secondCol}>
						  <h2
							data-layout={!loggedIn ? 'padding-top--smm margin-top--md margin-bottom--md' : ''}>{__t('Фактура')}</h2>
					  </div>
				  </div>

				  {/* ------------- ФИЗИЧЕСКО ЛИЦЕ ------------- */}
				  {this.getPersonalCompanyForm()}

				  {/* ------------- АКО ИМА САМО ЕДНА (ИЛИ ОПРЕДЕЛЕН БРОЙ) ФИРМА ------------- */}
				  {
					companiesData.length >= 1 &&
					<div data-test="existing_companies_container">
						{
							companiesData.map((companyData, k) =>
							  [
								  <div className={styles.row} key={k}>
									  <div className={styles.firstCol}>
										  <Radio
											value={companyData.company_id}
											id={companyData.company_id}
											checked={companyData.company_id === this.newCompanyId ? this.selectedCompanyData.company_name !== '' && this.selectedCompanyData.company_name === companyData.company_name && (this.selectedMode === 'with_existing_company' || this.selectedMode === 'edit_existing') : this.selectedCompanyId === companyData.company_id && (this.selectedMode === 'with_existing_company' || this.selectedMode === 'edit_existing')}
											labelClass={styles.companyRadio}
											onChange={() => this.onChangeExistingCompany(companyData)}/>
									  </div>
									  <div className={styles.secondCol}>

										  <label htmlFor={companyData.company_id}>
											  {companyData.company_name}
										  </label>
									  </div>
								  </div>,
								  (this.selectedMode === 'edit_existing') && this.props.allowNewCompany ?
									''
									:
									(this.selectedCompanyId === companyData.company_id) &&
									<ExistingCompanyInfo
									  key={k + '0'}
									  editExistingCompany={this.editExistingCompany}
									  allowEdit={companiesData.length > 0 && this.props.allowNewCompany}
									  companyInfo={this.findCompanyById(this.selectedCompanyId)}/>
							  ]
							)
						}
					</div>

				  }

			  </div>

			  {/* ------------- ФОРМАТА ЗА РЕДАКТИРАНЕ НА ФИРМА ------------- */}
			  {(this.selectedMode === 'edit_existing') && this.props.allowNewCompany ?
				<ComponentCompanyForm
				  data={tmpCompanyForm}
				  ref={this.companyRef}
				  cancelButtonAction={this.cancelEdit}
				  editMode={this.selectedMode === 'edit_existing'}
				  showSaveButton={this.props.showCompanyFormSaveButtonForEdit}
				  saveAction={this.saveCompanyData}
				  closeButtonHide={true}
				/>
				: ''}
		  </>
		);

	}

	render() {

		this.selectedCompanyData = this.context.get(this.componentName + 'scompd');

		const {
			companiesData
		} = this.data;

		// https://ps.superhosting.bg/projects/483/tasks/51372
		// Ако няма въведени фирми, показваме линк Добави фирма, и го пренасочваме към контактните данни

		if ((companiesData.length === 0 && !this.props.allowNewCompany) || (this.props.disableInvoiceBlock === true && this.selectedCompanyData.company_name === '')) {
			if (this.props.showInPage === true) {
				return <section data-layout="margin-top--20">
					<a href="/web-hosting-order-client-data.php"
					   title={__t('Добавяне на фирма')}>{__t('Добавяне на фирма')}</a>
				</section>;
			} else {
				return null;
			}
		}

		return (
		  <>
			  {companiesData.length <= 1 ? this.getSingleCompanyForm() : ''}
			  {companiesData.length > 1 ? this.getMultipleCompanyForm() : ''}

			  {this.getAddNewCompanyForm()}

			  {(typeof this.props.submitForm === 'function') && (this.selectedMode !== 'with_company_form') && (this.selectedMode !== 'edit_existing') &&
				<div data-layout={`text-center hide@md`} className={styles.mt35}>
					<Button
					  name={'do_submit'}
					  id={'szgwoqm76u'}
					  value={__t('Продължи с поръчката')}
					  onClick={this.props.submitForm}/>
				</div>
			  }
		  </>
		);
	}
}


// React Context binding
ComponentInvoiceBlock.contextType = ContextDataStore;

export default ComponentInvoiceBlock;